import { useState, useEffect, useContext, useCallback, useMemo } from "react"
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useFormContext } from "../context/FormContext";

import { TRAMITACIONES_EXTERNAS_INICIAL } from '../utils/initialStates';
import { PAGO_MEJORAS_INICIAL, PAGO_MICROCREDITOS_INICIAL, PAGO_PROYECTOS_INICIAL, PAGO_INTERVENCIÓN_SOCIAL_INICIAL, PAGO_CAPACITACIONES_INICIAL } from '../utils/initialStates';

import InfoButtonWithPopover from "./InfoButtonWithPopover";
import TramitacionExternaRow from "./TramitacionExternaRow";
import ObservacionesHistorial from "./ObservacionesHistorial";

import { Input, Label, Button } from "../components/ui"
import ExpedienteProyecto, { toFlat } from "./ExpedienteProyecto";
//import { optionsPartido, optionsTipoSubsidio, optionsEncargadoProyecto, optionsPrograma, optionsTipoContratacion, optionsTipoProyecto } from "../datos/options"

//import io from "socket.io-client"; //13-ENE-25
import { requisitos } from '../datos/requisitos';

import { AuthContext } from "../context/authContext";
import { useEstadoApp } from "../context/EstadoAppContext";
import { SocketContext } from "../context/socketContext";

const FormB_Tramitacion = () => {
    const socket = useContext(SocketContext);
    const { user } = useContext(AuthContext);
    // Obtener los datos del contexto
    const {
        formB,
        updateField,
        updateObservacion,
        updateTramitaciones,
        updateTramitacionInterna,
        updateFormB,
        formA,
        loadFormC,
        loadFormB
    } = useFormContext();

    // Extraer los valores necesarios de formA
    const {
        datosGenerales = {},
        array_obras_expediente = []
    } = formA;

    // Extraer los valores necesarios de formB
    const {
        //observacionesReporteEntidad = '',
        //observacionesInternas = '',
        //observacionesTramitacionExterna = '',
        selectedRequisitos = {},
        tramitacion = {},
        //tramitacionesExternas = [],
        fechaSalidaConvenio,
        fechaFirmaConvenio,
        fechaSalidaResolucion,
        fechaFirmaResolucion
    } = formB || {};

    const tramitacionesExternas = formB?.tramitacionesExternas || [];
    console.log('Render tramitacionesExternas de FormB', tramitacionesExternas);

    // Fila para el caso en que no hay ningun registro de tramitacion externa todavia.
    // Antes se renderizaba `tramitacionesExternas[0]` sobre un array vacio, o sea
    // `undefined`: el componente cae en su default `{}`, queda sin `id`, y el
    // `onUpdate(undefined, ...)` lo descarta el `if (!tramitacionId) return` de
    // handleTramitacionExternaUpdate. El input aceptaba la fecha pero no se guardaba
    // nunca, asi que se veia el placeholder y el usuario no podia cargar nada.
    const filaVacia = useMemo(() => ({
        id: 'nueva-tramitacion',
        exp: '',
        objeto: '',
        fecha_salida_convenio: null,
        fecha_firma_convenio: null,
        fecha_salida_reso: null,
        fecha_firma_reso: null,
    }), []);

    const observacionesReporteEntidad = formB?.observaciones?.reporteEntidad;
    const observacionesInternas = formB?.observaciones?.internas;
    const observacionesTramitacionExterna = formB?.observaciones?.tramitacionExterna;
    const internasHistorico = formB?.internasHistorico || [];
    const expedienteProyectoFlat = formB?.expedienteProyecto || [];
    const esMicrocreditos = datosGenerales.area_responsable === 'ÁREA DE MICROCRÉDITOS';

    const { orgDocsExpanded, expedienteProyecto } = useMemo(() => {
        if (!expedienteProyectoFlat || expedienteProyectoFlat.length === 0) return { orgDocsExpanded: false, expedienteProyecto: null };
        const toCamel = item => ({
            ...item,
            isChecked: item.is_checked !== undefined ? item.is_checked : item.isChecked,
            org_docs_expanded: item.org_docs_expanded !== undefined ? item.org_docs_expanded : item.orgDocsExpanded,
        });
        const mapped = expedienteProyectoFlat.map(toCamel);
        return {
            orgDocsExpanded: mapped[0]?.org_docs_expanded || false,
            expedienteProyecto: {
                orgDocs: mapped.filter(f => f.seccion === 'orgDocs'),
                projectDocs: mapped.filter(f => f.seccion === 'projectDocs'),
                pv: mapped.filter(f => f.seccion === 'pv'),
            },
        };
    }, [expedienteProyectoFlat]);

    const handleExpedienteProyectoChange = useCallback((data) => {
        const expanded = data && data.orgDocsExpanded !== undefined ? data.orgDocsExpanded : false;
        const flat = [
            ...toFlat('orgDocs', data.orgDocs || [], expanded),
            ...toFlat('projectDocs', data.projectDocs || [], expanded),
            ...toFlat('pv', data.pv || [], expanded),
        ];
        updateField('formB', 'expedienteProyecto', null, flat);
    }, [updateField]);

    //tramitacionInterna

    const tramitacionInterna = [
        {
            id: 'registracion_ong',
            label: 'Registración ONG',
            //isEnabled: () => tipoSubsidio && tipoSubsidio === 'Subsidio a ONG'
            isEnabled: () => {
                const tipo = datosGenerales.tipo_subsidio;
                return tipo === 'Subsidio a ONG';
            }
        },
        {
            id: 'resolucion_ong',
            label: 'Resolución ONG',
            //isEnabled: () => tipoSubsidio === 'Subsidio a ONG'
            isEnabled: () => {
                const tipo = datosGenerales.tipo_subsidio;
                return tipo === 'Subsidio a ONG';
            }
        },
        {
            id: 'documentacion_ong',
            label: 'Documentación ONG',
            //isEnabled: () => tipoSubsidio === 'Subsidio a ONG'
            isEnabled: () => {
                const tipo = datosGenerales.tipo_subsidio;
                return tipo === 'Subsidio a ONG';
            }
        },
        //Informe Técnico siempre visible (nuevo requisito 22-jul-2025)
        {
            id: 'informe_tecnico',
            label: 'Informe Técnico',
            isEnabled: () => true
        },
        {
            id: 'modelo_convenio',
            label: 'Modelo de convenio',
            //isEnabled: () => areaResponsable === 'ÁREA DE MEJORAS' || areaResponsable === 'ÁREA DE MICROCRÉDITOS'
            isEnabled: () => {
                const area = datosGenerales.area_responsable;
                return area === 'ÁREA DE MEJORAS' || area === 'ÁREA DE MICROCRÉDITOS';
            }
        },
        {
            id: 'proyecto_resolucion',
            label: 'Proyecto de resolución',
            //isEnabled: () => areaResponsable === 'ÁREA DE MEJORAS' || areaResponsable === 'ÁREA DE MICROCRÉDITOS'
            isEnabled: () => {
                const area = datosGenerales.area_responsable;
                return area === 'ÁREA DE MEJORAS' || area === 'ÁREA DE MICROCRÉDITOS';
            }
        },
        /* por ahora sin casos especiales
        {
            id: 'desembolso',
            label: 'Desembolso + fecha',
            hasDate: true,// Indica que este ítem tiene un campo de fecha
            isEnabled: () => areaResponsable === 'ÁREA DE MEJORAS'
        },
        {
            id: '90_dias',
            label: '90 dias el + fecha',
            hasDate: true,// Indica que este ítem tiene un campo de fecha
            isEnabled: () => areaResponsable === 'ÁREA DE MEJORAS'
        },
        {
            id: 'mail_contacto',
            label: 'Mail contacto + cuadro abierto',
            isEnabled: () => areaResponsable === 'ÁREA DE MEJORAS'
        },
        {
            id: 'firma_convenio',
            label: 'Firma convenio + fecha',
            hasDate: true,// Indica que este ítem tiene un campo de fecha
            isEnabled: () => areaResponsable === 'ÁREA DE MEJORAS'
        },
        {
            id: 'convenio_escaneado',
            label: 'Convenio escaneado',
            isEnabled: () => areaResponsable === 'ÁREA DE MEJORAS'
        },
        */
        {
            id: 'dni_presidente_ong',
            label: 'DNI Presidente',
            /*isEnabled: () => 
                tipoSubsidio === 'Subsidio a ONG' && 
                (areaResponsable === 'ÁREA DE MEJORAS' || areaResponsable === 'ÁREA DE MICROCRÉDITOS')*/
            isEnabled: () => {
                const tipo = datosGenerales.tipo_subsidio;
                const area = datosGenerales.area_responsable;
                return tipo === 'Subsidio a ONG' && (area === 'ÁREA DE MEJORAS' || area === 'ÁREA DE MICROCRÉDITOS');
            }
        },
        {
            id: 'dni_intendente',
            label: 'DNI Intendente',
            /*isEnabled: () => 
                tipoSubsidio === 'Subsidio a municipio' && 
                (areaResponsable === 'ÁREA DE MEJORAS' || areaResponsable === 'ÁREA DE MICROCRÉDITOS')*/
            isEnabled: () => {
                const tipo = datosGenerales.tipo_subsidio;
                const area = datosGenerales.area_responsable;
                return tipo === 'Subsidio a municipio' && (area === 'ÁREA DE MEJORAS' || area === 'ÁREA DE MICROCRÉDITOS');
            }
        },
        {
            id: 'poliza',
            label: 'Póliza',
            /*isEnabled: () => areaResponsable === 'ÁREA DE MEJORAS' || areaResponsable === 'ÁREA DE MICROCRÉDITOS'*/
            isEnabled: () => {
                const area = datosGenerales.area_responsable;
                return area === 'ÁREA DE MEJORAS' || area === 'ÁREA DE MICROCRÉDITOS';
            }
        },
        {
            id: 'cbu',
            label: 'CBU',
            /*isEnabled: () => areaResponsable === 'ÁREA DE MEJORAS' || areaResponsable === 'ÁREA DE MICROCRÉDITOS'*/
            isEnabled: () => {
                const area = datosGenerales.area_responsable;
                return area === 'ÁREA DE MEJORAS' || area === 'ÁREA DE MICROCRÉDITOS';
            }
        },
        {
            id: 'nota_solicitud',
            label: 'Nota de solicitud',
            /*isEnabled: () => areaResponsable === 'ÁREA DE MEJORAS' || areaResponsable === 'ÁREA DE MICROCRÉDITOS'*/
            isEnabled: () => {
                const area = datosGenerales.area_responsable;
                return area === 'ÁREA DE MEJORAS' || area === 'ÁREA DE MICROCRÉDITOS';
            }
        },
        {
            id: 'acta_designacion',
            label: 'Acta designación',
            /*isEnabled: () => areaResponsable === 'ÁREA DE MEJORAS' || areaResponsable === 'ÁREA DE MICROCRÉDITOS'*/
            isEnabled: () => {
                const area = datosGenerales.area_responsable;
                return area === 'ÁREA DE MEJORAS' || area === 'ÁREA DE MICROCRÉDITOS';
            }
        },
        {
            id: 'programa',
            label: 'Programa',
            // Siempre habilitado
            isEnabled: () => true
        },

        // Separador entre Programa y Resolución
        {
            id: 'separador',
            label: <hr className="border-gray-300" />,
            isEnabled: () => true,
            isSeparator: true
        },
        {
            id: 'resolucion',
            label: 'Resolución',
            // Siempre habilitado
            isEnabled: () => true
        },
        {
            id: 'documentacion_pago_ok',
            label: 'Documentación para el pago',
            isEnabled: () => true
        }
    ];

    const tramitacionInternaSeleccionada = tramitacionInterna
        .filter(item => tramitacion && tramitacion[item.id])
        .map(item => item.label)
        .join(', ');

    // Obtener lista de requisitos seleccionados para mostrar
    const requisitosSeleccionados = requisitos
        .filter(req => selectedRequisitos && selectedRequisitos[req.id])
        .map(req => req.label)
        .join(', ');




    // Manejar cambios en los checkboxes ---->ahora se maneja en el padre
    /*const handleRequisitoChange = (requisitoId, isChecked) => {
        setSelectedRequisitos(prev => ({
            ...prev,
            [requisitoId]: isChecked
        }));
        
        // Si se desmarca un campo de fecha, limpiar la fecha
        if (!isChecked && (requisitoId === 'desembolso_fecha' || requisitoId === '90_dias_fecha' || requisitoId === 'firma_convenio_fecha')) {
            setFechasRequisitos(prev => ({
                ...prev,
                [requisitoId]: null
            }));
        }
    };*/

    // Manejar cambio de fechas ---->ahora se maneja en el padre
    /*const handleFechaChange = (requisitoId, date) => {
        setFechasRequisitos(prev => ({
            ...prev,
            [requisitoId]: date
        }));
    };*/

    // Manejar cambio de email de contacto ---->ahora se maneja en el padre
    /*const handleEmailChange = (e) => {
        setEmailContacto(e.target.value);
    };*/

    //El estado se define en el padre, pero igualmente se crean la lista de los items 
    /*const items = [
        "Nota de solicitud",
        "Informes de dominio",
        "Registración ONG",
        "Designación Intendente",       
        "Anexo social",
        "Anexo técnico",
        "Cómputo y presupuesto",
        "Planos de proyecto",
        "Prefactibilidad/es de servicio/s suscripta por la prestataria",
        "Constancia de CBU",        
        "Acta acuerdo"
    ];*/
    const items = [
        { label: "Nota de solicitud", value: "nota_de_solicitud" },
        { label: "Informes de dominio", value: "informes_de_dominio" },
        { label: "Registración ONG", value: "registracion_ong" },
        { label: "Designación Intendente", value: "designacion_intendente" },
        { label: "Anexo social", value: "anexo_social" },
        { label: "Anexo técnico", value: "anexo_tecnico" },
        { label: "Cómputo y presupuesto", value: "computo_y_presupuesto" },
        { label: "Planos de proyecto", value: "planos_de_proyecto" },
        { label: "Prefactibilidad/es de servicio/s suscripta por la prestataria", value: "prefactibilidad_es_de_servicio_s_suscripta_prestataria" },
        { label: "Constancia de CBU", value: "constancia_de_cbu" },
        { label: "Acta acuerdo", value: "acta_acuerdo" }
    ]

    /* como netar durnate la migracion #2dic25
    useEffect(() => { // Nuevo useEffect para resetear valores al cambiar tipoSubsidio
        if (tipoSubsidio) {
            // Determinar si "Registración ONG" debe estar deshabilitado
            const isRegistracionOngDisabled = tipoSubsidio !== "Subsidio a ONG";
            // Determinar si "Designación Intendente" debe estar deshabilitado
            const isDesignacionIntendenteDisabled = tipoSubsidio !== "Subsidio a municipio";

            console.log(`[useEffect] tipoSubsidio: ${tipoSubsidio}`); // Log del tipoSubsidio actual


            // Si "Registración ONG" se deshabilita y estaba seleccionado, resetear su valor
            if (isRegistracionOngDisabled && selectedRequisitos["registracion_ong"]) {
                handleCheckboxChange("registracion_ong", false);
            }
            // Si "Designación Intendente" se deshabilita y estaba seleccionado, resetear su valor
            if (isDesignacionIntendenteDisabled && selectedRequisitos["designacion_intendente"]) {
                handleCheckboxChange("designacion_intendente", false);
            }
        }
    }, [tipoSubsidio, selectedRequisitos, handleCheckboxChange]); // Dependencias del useEffect: tipoSubsidio, selectedItems y handleCheckboxChange
    */

    //contador de caracteres #19NOV25:
    //podría definir un limite constante, pero de esta manera se puede usar para cualquier input e ir variando el limite
    /*const contadorCaracteresRestantes = (limite, longitudActual) => {
        if(limite && longitudActual){
            //a limite restarle la longitud actual
            const restantes = limite - longitudActual;
            return restantes;
        }
        return limite;
    }*/
    const contadorCaracteresRestantes = (limite, texto) => {
        // Si el texto es null o undefined, usar string vacío
        const longitud = texto ? texto.length : 0;
        // Asegurarse de que el límite sea un número válido
        const limiteValido = limite || 0;
        // Calcular caracteres restantes, asegurando que no sea negativo
        return Math.max(0, limiteValido - longitud);
    }
    //NUEVA #19NOV
    /*
    const handleInputChange = useCallback((event) => {
        const { name, value } = event.target;
        //console.log("name", name)
        //console.log("value", value)

        // Actualiza una parte del 'registro' existente, manteniendo la inmutabilidad
        //agregar casos especiales
        if (name === 'observacionesReporteEntidad') {
            //primero actualizamos el estado local para el contador
            setTextInput1(value);
            handleObservacionesReporteEntidadChange(event);
        } else if (name === 'observacionesInternas') {
            //primero actualizamos el estado local para el contador
            setTextInput2(value);
            handleObservacionesInternasChange(event);
        } else if (name === 'observacionesTramitacionExterna') {
            //primero actualizamos el estado local para el contador
            setTextInput3(value);
            handleObservacionesTramitacionExternaChange(event);
        }
    }, [registro]);
    */
    // Manejadores actualizados para usar el contexto
    const handleObservacionesReporteEntidadChange = (e) => {
        const value = e.target.value;
        updateObservacion('reporteEntidad', value);
    };

    const handleObservacionesInternasChange = (e) => {
        const value = e.target.value;
        updateObservacion('internas', value);
    };

    const handleObservacionesTramitacionExternaChange = (e) => {
        const value = e.target.value;
        updateObservacion('tramitacionExterna', value);
    };

    const handleInternasHistoricoChange = (nuevoArray) => {
        updateFormB({ internasHistorico: nuevoArray }, 'formB_observaciones');
    };

    const handleRequisitoChange = (requisitoId, isChecked) => {
        updateField('formB', 'selectedRequisitos', requisitoId, isChecked);
    };

    const handleTramitacionInternaChange = (field, value) => {
        updateTramitacionInterna({
            ...tramitacion,
            [field]: value
        });
    };

    const handleTramitacionExternaUpdate = useCallback((tramitacionId, updates) => { //updatedTramitacion
        if (!updates) return;
        if (!tramitacionId) {
            // Antes el `!tramitacionId` salia acá junto con el `!updates` y el
            // return era silencioso: la fila se veia editable pero la fecha no se
            // guardaba. Ahora queda a la vista si vuelve a pasar.
            console.warn("handleTramitacionExternaUpdate: update sin id de fila, se descarta", updates);
            return;
        }
        console.log("LEON updates", updates)

        const tramitacionesActuales = [...tramitacionesExternas];
        console.log("LEON tramitacionesActuales", tramitacionesActuales)
        const index = tramitacionesActuales.findIndex(t => t.id === tramitacionId);

        if (index === -1) {
            // Si no existe, agregar. Se mergea sobre la fila base para no perder
            // exp/objeto: antes se guardaba solo `updates`, o sea la fila nueva
            // aparecia sin expediente.
            tramitacionesActuales.push({
                ...(tramitacionesExternas[0] || filaVacia),
                ...updates,
                id: tramitacionId
            });
        } else {
            console.log("LEON actualizar", index)
            // Si existe, actualizar
            tramitacionesActuales[index] = {
                ...tramitacionesActuales[index],
                ...updates
            };
        }

        updateTramitaciones('externas', tramitacionesActuales);
    }, [tramitacionesExternas, updateTramitaciones, filaVacia]);

    const { estadoAppX, cambiarEstadoApp, setIdEtapa1 } = useEstadoApp();

    const handleCreateSecondStage = () => {
        const dbId = formA?.id || formA?.datosGenerales?.id;
        const idPartidoObra = formA?.id_partido_obra || formA?.datosGenerales?.id_partido_obra;
        const esMicrocreditos = datosGenerales?.area_responsable === 'ÁREA DE MICROCRÉDITOS';
        const labelEtapa = esMicrocreditos ? 'Rendición' : 'Etapa II';

        console.log("DEBUG: handleCreateSecondStage iniciado");
        console.log("DEBUG: formA =", formA);
        console.log("DEBUG: dbId =", dbId, "idPartidoObra =", idPartidoObra);

        // Validar que tenemos el ID del expediente
        if (!dbId) {
            alert("Error: No se encontró el ID del expediente actual");
            return;
        }

        // Confirmar con el usuario antes de salir
        const confirmar = window.confirm(
            `Está por crear ${esMicrocreditos ? 'la Rendición' : 'la Etapa II'} del expediente ${idPartidoObra}.\n\n` +
            `Se creará un nuevo expediente vinculado al actual.\n\n` +
            `IMPORTANTE: Asegúrese de haber guardado los cambios del expediente actual antes de continuar.\n\n` +
            `¿Desea continuar?`
        );

        if (!confirmar) {
            return;
        }

        // Guardar el ID de base de datos para el fetch en InicioPage
        setIdEtapa1(dbId);
        console.log("DEBUG: Guardando dbId =", dbId, "para fetch en InicioPage");

        // Liberar el bloqueo de edición de la obra Etapa I
        const idObraActual = formA?.id_partido_obra || formA?.datosGenerales?.id_partido_obra;
        if (idObraActual && socket) {
            socket.emit("quitar_id_edicion", idObraActual, user);
            console.log("DEBUG: Lock liberado para obra Etapa I:", idObraActual);
        }

        // IMPORTANTE: Limpiar el formulario ANTES de cambiar el estado
        // Esto asegura que el nuevo expediente (Etapa II / Rendición) empiece con datos limpios
        console.log("DEBUG: Limpiando formulario para", labelEtapa, "...");

        // Resetear los formularios formB y formC a valores iniciales.
        // Esto es necesario porque el useEffect en InicioPage se ejecuta DESPUÉS del cambio de estado
        // y si no limpiamos aquí, el formulario mantendría los datos de Etapa I momentáneamente.
        loadFormB({
            selectedRequisitos: {},
            tramitacion: {},
            tramitacionesExternas: [],
            observaciones: {
                reporteEntidad: '',
                internas: '',
                tramitacionExterna: ''
            },
            internasHistorico: [],
            expedienteProyecto: [],
            orgDocsExpanded: false
        });
        loadFormC({
            seguimientoObra: {
                encargadoSeguimiento: '',
                montoObra: '',
                fechaInicioObra: '',
                fechaFinObra: '',
                observaciones: ''
            },
            arrayPagosMejoras: [...PAGO_MEJORAS_INICIAL],
            arrayPagosMicrocreditos: [...PAGO_MICROCREDITOS_INICIAL],
            arrayPagosProyectos: [...PAGO_PROYECTOS_INICIAL],
            arrayPagosIntervencionSocial: [...PAGO_INTERVENCIÓN_SOCIAL_INICIAL],
            arrayPagosCapacitaciones: [...PAGO_CAPACITACIONES_INICIAL],
            porcentaje_parcial_2do_pago: null,
            porcentaje_parcial_3er_pago: null,
            arrayMediciones: [],
            arrayMejorasEtapaI: [],
            arrayMejorasEtapaII: [],
            arrayCircuitoAdmin: []
        });
        // NOTA: El useEffect en InicioPage se encargará de establecer etapa=2 e id_exp_proy_referencia

        // Cambiar al estado nuevo_etapa2
        // El useEffect en InicioPage detectará este cambio y configurará los valores de Etapa II / Rendición
        console.log("DEBUG: Cambiando estado a 'nuevo_etapa2'");
        cambiarEstadoApp('nuevo_etapa2');
        console.log("DEBUG: Estado cambiado - El useEffect en InicioPage configurará los valores de", labelEtapa);
    };

    useEffect(() => {
        console.log('Estado actual de tramitacionesExternas:', tramitacionesExternas);
    }, [tramitacionesExternas]);


    return (
        <div className="p-4 bg-white dark:bg-gray-900 min-h-screen">
            <div className="flex flex-row">
                <h2 className="text-xl font-bold dark:text-white mb-2">TRAMITACIÓN</h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                <div>
                    <Label htmlFor="tipoSubsidio">Tipo de subsidio</Label>
                    <div className="mt-2">
                        <Input
                            disabled={true}
                            id="tipoSubsidio"
                            name="tipoSubsidio"
                            placeholder="Tipo de subsidio"
                            value={datosGenerales.tipo_subsidio}
                        />
                    </div>
                </div>

                <div>
                    <Label htmlFor="areaResponsable">Area responsable</Label>
                    <div className="mt-2">
                        <Input
                            disabled={true}
                            id="areaResponsable"
                            name="areaResponsable"
                            placeholder="Area responsable"
                            value={datosGenerales.area_responsable || ''}
                        />
                    </div>
                </div>
            </div>



            <div className="mt-6">
                <h3 className="text-lg font-semibold mb-4">Documentación</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    {/* Columna de Requisitos */}
                    <div className={`space-y-3 ${esMicrocreditos ? 'opacity-60 pointer-events-none' : ''}`}>
                        <h4 className="text-md font-semibold mb-3 text-gray-700">Requisitos</h4>
                        <div className="space-y-2 max-h-[500px] overflow-y-auto p-2 border rounded">
                            {requisitos
                                .filter((requisito) => {
                                    // Filtrar requisitos según la etapa
                                    const etapaActual = datosGenerales.etapa || 1;
                                    const requisitoEtapa = requisito.etapa;

                                    // Si es Etapa II (etapa === 2), mostrar SOLO requisitos de etapa 2
                                    if (etapaActual === 2) {
                                        return requisitoEtapa === 2;
                                    }

                                    // Para Etapa I: mostrar requisitos de etapa 1 o sin etapa (comunes)
                                    if (requisitoEtapa === undefined || requisitoEtapa === 1) {
                                        return true;
                                    }

                                    return false;
                                })
                                .map((requisito) => {
                                    const isEnabled = requisito.isEnabled(datosGenerales.area_responsable, datosGenerales.tipo_subsidio);

                                    if (requisito.isSectionHeader) {
                                        // Mostrar encabezado solo si está habilitado
                                        if (!isEnabled) return null;
                                        return (
                                            <div key={requisito.id} className="mt-4 mb-2">
                                                <h5 className="font-bold text-blue-700">{requisito.label}</h5>
                                            </div>
                                        );
                                    }

                                    return (
                                        <>
                                            {isEnabled && (
                                                <div key={requisito.id} className="flex items-center">
                                                        <input
                                                            type="checkbox"
                                                            id={`requisito-${requisito.id}`}
                                                            checked={selectedRequisitos[requisito.id] || false}
                                                            onChange={(e) => handleRequisitoChange(requisito.id, e.target.checked)}
                                                            disabled={!isEnabled || esMicrocreditos}
                                                            className={`h-4 w-4 rounded border-gray-300 ${(!isEnabled || esMicrocreditos) ? 'opacity-50' : 'text-blue-600'}`}
                                                        />
                                                    <label
                                                        htmlFor={`requisito-${requisito.id}`}
                                                        className={`ml-2 text-sm ${!isEnabled ? 'text-gray-500' : 'text-gray-700'}`}
                                                    >
                                                        {requisito.label}
                                                        {!isEnabled && ' (No aplica)'}
                                                    </label>
                                                </div>
                                            )}
                                        </>
                                    );
                                })}
                        </div>

                        {requisitosSeleccionados && (
                            <p className="mt-3 p-2 bg-blue-50 text-blue-800 rounded-md text-sm">
                                <span className="font-medium">Seleccionados:</span> {requisitosSeleccionados}
                            </p>
                        )}

                        {/* Microcréditos Etapa 2: checks de Exp. Proyecto desactivados + nuevos checks de Rendición */}
                        {datosGenerales.area_responsable === 'ÁREA DE MICROCRÉDITOS' && (datosGenerales.etapa === 2 || datosGenerales.tipo_microcredito === 'EXP_RENDIC') && (
                            <div className="mt-4 p-3 border border-purple-200 dark:border-purple-800 bg-purple-50 dark:bg-purple-900/20 rounded-lg space-y-3">
                                <h5 className="font-bold text-purple-700 dark:text-purple-300 text-sm">EXP. DE PROYECTO (Completado)</h5>
                                <div className="flex items-center opacity-60">
                                    <input type="checkbox" checked={true} disabled className="h-4 w-4 rounded border-gray-300 text-blue-600" />
                                    <label className="ml-2 text-sm text-gray-500">Nota de solicitud</label>
                                </div>
                                <div className="flex items-center opacity-60">
                                    <input type="checkbox" checked={true} disabled className="h-4 w-4 rounded border-gray-300 text-blue-600" />
                                    <label className="ml-2 text-sm text-gray-500">Constancia de CBU</label>
                                </div>
                                <div className="flex items-center opacity-60">
                                    <input type="checkbox" checked={true} disabled className="h-4 w-4 rounded border-gray-300 text-blue-600" />
                                    <label className="ml-2 text-sm text-gray-500">Proyectos / Planos</label>
                                </div>
                                <hr className="border-purple-200 dark:border-purple-700 my-2" />
                                <h5 className="font-bold text-purple-700 dark:text-purple-300 text-sm">EXP. DE RENDICIÓN</h5>
                                <div className="flex items-center">
                                    <input
                                        type="checkbox"
                                        id="requisito-ddjj_rendicion"
                                        checked={selectedRequisitos['ddjj_rendicion'] || false}
                                        onChange={(e) => handleRequisitoChange('ddjj_rendicion', e.target.checked)}
                                        className="h-4 w-4 rounded border-gray-300 text-blue-600"
                                    />
                                    <label htmlFor="requisito-ddjj_rendicion" className="ml-2 text-sm text-gray-700">
                                        DDJJ de recepción de fondos + extracto bancario
                                    </label>
                                </div>
                                <div className="flex items-center">
                                    <input
                                        type="checkbox"
                                        id="requisito-providencia_rendicion"
                                        checked={selectedRequisitos['providencia_rendicion'] || false}
                                        onChange={(e) => handleRequisitoChange('providencia_rendicion', e.target.checked)}
                                        className="h-4 w-4 rounded border-gray-300 text-blue-600"
                                    />
                                    <label htmlFor="requisito-providencia_rendicion" className="ml-2 text-sm text-gray-700">
                                        Providencia de inicio de rendición
                                    </label>
                                </div>
                            </div>
                        )}

                        {/*si area de mejoras, mostrar un button para crear 2da etapa
                        crear una funcion handleCreateSecondStage()
                        */}
                        {/*slo visible para user === JAvier*/}
                        {datosGenerales.area_responsable === 'ÁREA DE MEJORAS' &&
                            datosGenerales?.id_partido_obra &&
                            estadoAppX !== 'edit_etapa2' &&
                            ((datosGenerales.etapa || 1) !== 2 && datosGenerales.tipo_microcredito !== 'EXP_RENDIC') && (
                                <div className="mt-3">
                                    {datosGenerales.tiene_etapa2 ? (
                                        <div className="space-y-2">
                                            <Button
                                                disabled={true}
                                                className="opacity-50 cursor-not-allowed"
                                            >
                                                Crear 2da etapa
                                            </Button>
                                            <p className="text-sm text-amber-600">
                                                ⚠️ Ya existe el expediente con {datosGenerales.area_responsable === 'ÁREA DE MICROCRÉDITOS' ? 'Rendición' : 'Etapa II'} vinculada {datosGenerales.id_etapa2_asociada && `(ID: ${datosGenerales.id_etapa2_asociada})`}
                                            </p>
                                        </div>
                                    ) : (
                                        <Button
                                            onClick={() => handleCreateSecondStage()}
                                        >
                                            Crear 2da etapa
                                        </Button>
                                    )}
                                </div>
                            )}

                    </div>

                    {/* Columna de Tramitación Interna */}
                    <div className={`space-y-3 ${esMicrocreditos ? 'opacity-60 pointer-events-none' : ''}`}>
                        <div className="flex flex-row">
                            <h4 className="text-md font-semibold mb-3 text-gray-700">Tramitación Interna</h4>
                            <InfoButtonWithPopover infoText="EN TESTEO." />
                        </div>

                        <div className="space-y-2 max-h-[500px] overflow-y-auto p-2 border rounded">
                            {(tramitacionInterna || []).map((item) => {
                                const isEnabled = item.isEnabled();
                                const isChecked = tramitacion[item.id] || false;

                                // Renderizar campos especiales //COMENTAR 22-JUL-2025: por ahora no se usa
                                const renderSpecialField = () => {
                                    if (['desembolso', '90_dias', 'firma_convenio'].includes(item.id) && isChecked) {
                                        return (
                                            <DatePicker
                                                //selected={fechasTramitaciones[item.id] || null}
                                                selected={tramitacion[`${item.id}_fecha`] || null}
                                                //onChange={(date) => onTramitacionesInternasChange(`${item.id}_fecha`, date)} //onFechaTramitacionChange
                                                onChange={(date) => handleTramitacionInternaChange(
                                                    `${item.id}_fecha`,
                                                    date
                                                )}
                                                dateFormat="dd/MM/yyyy"
                                                placeholderText="Seleccionar fecha"
                                                className="ml-3 text-sm border rounded p-1 w-40"
                                                disabled={!isEnabled}
                                            />
                                        );
                                    }

                                    if (item.id === 'mail_contacto' && isChecked) {
                                        return (
                                            <input
                                                type="email"
                                                value={tramitacion.mail_contacto_correo || ''}//{emailContacto}
                                                //onChange={(e) => onTramitacionesInternasChange('mail_contacto_correo', e.target.value)}//{onEmailContactoChange}
                                                onChange={(e) => handleTramitacionInternaChange('mail_contacto_correo', e.target.value)}
                                                placeholder="Ingrese el correo"
                                                className="ml-3 text-sm border rounded p-1 w-64"
                                                disabled={!isEnabled}
                                            />
                                        );
                                    }
                                    return null;
                                }; //hasta acá no se usa (22-jul-2025)

                                // Si es un separador, mostrarlo como un <hr> sin checkbox
                                if (item.id === 'separador') {
                                    return (
                                        <div key={item.id} className="my-2">
                                            <hr className="my-4 border-gray-300" />
                                        </div>
                                    );
                                }

                                // Para los demás elementos, mostrar el checkbox normal
                                return (
                                    <>
                                        {isEnabled && (
                                            <div key={item.id} className="mb-2">
                                                <div className="flex items-center">
                                                    <input
                                                        type="checkbox"
                                                        id={`tramitacion-${item.id}`}
                                                        checked={isChecked}
                                                        //checked={!!tramitacionesInternas[item.id]}
                                                        //onChange={(e) => onTramitacionesInternasChange(item.id, e.target.checked)}
                                                        onChange={(e) => handleTramitacionInternaChange(item.id, e.target.checked)}
                                                        className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                                        disabled={!isEnabled}
                                                    />
                                                    <label
                                                        htmlFor={`tramitacion-${item.id}`}
                                                        className={`ml-2 text-sm whitespace-nowrap ${!isEnabled ? 'text-gray-500' : 'text-gray-700'}`}
                                                    >
                                                        {item.id === '90_dias_fecha' ? '90 días el' : item.id === 'mail_contacto' ? 'Mail de contacto' : item.label}
                                                        {!isEnabled && ' (No aplica)'}
                                                    </label>
                                                    {/*renderSpecialField() //COMENTAR 22-JUL-2025: por ahora no se usa*/}
                                                </div>
                                            </div>
                                        )}
                                    </>
                                );
                            })}
                        </div>
                        {tramitacionInternaSeleccionada && (
                            <p className="mt-3 p-2 bg-blue-50 text-blue-800 rounded-md text-sm">
                                <span className="font-medium">Seleccionados:</span> {tramitacionInternaSeleccionada}
                            </p>
                        )}

                    </div>
                </div>
            </div>



            {esMicrocreditos && (
                <div className="mt-8">
                    <h3 className="text-lg font-semibold mb-4">Expediente de Proyecto</h3>
                    <ExpedienteProyecto
                        inicial={expedienteProyecto}
                        onChange={handleExpedienteProyectoChange}
                        expanded={orgDocsExpanded}
                        disabled={false}
                    />
                </div>
            )}

            <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-6 mb-4">

                <div>
                    <Label htmlFor="observacionesReporteEntidad">Observaciones para reporte a la entidad solicitante</Label>
                    <div className="mt-2">
                        <textarea
                            id="observacionesReporteEntidad"
                            name="observacionesReporteEntidad"
                            placeholder="Ingrese observaciones para reporte a la entidad solicitante"
                            rows="4"
                            value={observacionesReporteEntidad}
                            maxLength="2000"
                            onChange={handleObservacionesReporteEntidadChange}
                            //onChange={e => handleInputChange(e)}
                            className="w-full px-4 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:border-blue-500 dark:bg-gray-800 dark:text-white dark:border-gray-700 resize-y"
                        />
                    </div>
                    <div>
                        <p align="right" className="text-sm text-gray-500" style={{ height: "5px", fontSize: "0.9em" }}>
                            Caracteres restantes: {contadorCaracteresRestantes(2000, observacionesReporteEntidad)}
                        </p>
                    </div>
                </div>

                <ObservacionesHistorial
                    data={internasHistorico}
                    onChange={handleInternasHistoricoChange}
                    titulo="Observaciones internas"
                    placeholder="Ingrese observación interna"
                />
            </div>

            <div className="space-y-4">
                <div className="flex flex-row">
                    <h4 className="text-md font-semibold mb-3 text-gray-700">Tramitación Externa</h4>
                    <InfoButtonWithPopover infoText="EN TESTEO." />
                </div>

                {/* Mostrar al menos una fila vacía si no hay datos */}
                {(!tramitacionesExternas || tramitacionesExternas.length === 0) ? (
                    <TramitacionExternaRow
                        key="nueva-tramitacion"
                        tramitacion={filaVacia}
                        onUpdate={handleTramitacionExternaUpdate}
                        showHeaderLabels={true}
                    />
                ) : (
                    // Mostrar filas existentes
                    tramitacionesExternas.map((tramitacion, index) => (
                        <TramitacionExternaRow
                            key={tramitacion.id || `tramitacion-${index}`}
                            tramitacion={tramitacion}
                            onUpdate={handleTramitacionExternaUpdate}
                            showHeaderLabels={index === 0}
                        />
                    ))
                )}

                <div>
                    <Label htmlFor="observacionesTramitacionExterna">Observaciones a la tramitación externa</Label>
                    <div className="mt-2">
                        <textarea
                            id="observacionesTramitacionExterna"
                            name="observacionesTramitacionExterna"
                            placeholder="Ingrese observaciones a la tramitación externa"
                            rows="4"
                            value={observacionesTramitacionExterna}
                            maxLength="2000"
                            onChange={handleObservacionesTramitacionExternaChange}
                            //onChange={e => handleInputChange(e)}
                            className="w-full px-4 py-2 text-sm border border-gray-300 rounded-md focus:outline-none focus:border-blue-500 dark:bg-gray-800 dark:text-white dark:border-gray-700 resize-y"
                        />
                    </div>
                    <div>
                        <p align="right" className="text-sm text-gray-500" style={{ height: "5px", fontSize: "0.9em" }}>
                            Caracteres restantes: {contadorCaracteresRestantes(2000, observacionesTramitacionExterna)}
                        </p>
                    </div>
                </div>
            </div>

        </div>
    );

}

export default FormB_Tramitacion;
